import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import format from "date-fns/format";
import I18n from "i18next";
import subMonths from "date-fns/subMonths";

function getTimeRange(option) {
  if (option === I18n.t("common.months", { month: 3 })) {
    const start = format(startOfMonth(subMonths(new Date(), 2)), "yyyy-MM-dd");
    const end = format(endOfMonth(new Date()), "yyyy-MM-dd");
    return { start, end };
  } else if (option === I18n.t("common.months", { month: 6 })) {
    const start = format(startOfMonth(subMonths(new Date(), 5)), "yyyy-MM-dd");
    const end = format(endOfMonth(new Date()), "yyyy-MM-dd");
    return { start, end };
  } else {
    const start = format(startOfMonth(subMonths(new Date(), 11)), "yyyy-MM-dd");
    const end = format(endOfMonth(new Date()), "yyyy-MM-dd");
    return { start, end };
  }
}

export default getTimeRange;
